import React, { Component } from 'react';

import { LoginCourse } from '../../API/FetchCall';

import Cookies from 'universal-cookie';
import Recaptcha from 'react-recaptcha';
import { GOOGLE_CAPTCHA_SITE_KEY } from '../../constant.js';

class CourseLogin extends Component {


    constructor(props) {
        const cookies = new Cookies();
        super(props);
        this.state = {
            email_id: '',
            password: '',
            otp: '',
            verify_otp: true,
            auth_data: '',
            user_id: '',
            logged:false,
            phone_number: '',
            isVerified: false,
            showPassword: false,
            disabled: true,
            role:"",
            otp_check: cookies.get('otpVerified') ? cookies.get('otpVerified') : false,
        }
        this.recaptchaLoaded = this.recaptchaLoaded.bind(this);
        this.verifyCallback = this.verifyCallback.bind(this);
    }

    recaptchaLoaded = (e) => {
       console.log('Successfully loaded');
    }
    verifyCallback = (response) => {
        if (response) {
            this.setState({
                isVerified: true,
                disabled: false
            });
        }

    }
    handleChange = (e) => {
        this.setState({ [e.target.name]: e.target.value });

    };
    handleChangeOtp = (e) => {
        this.setState({ [e.target.name]: e.target.value.slice(0, e.target.maxLength) });

    };   

    handleSubmitLogin = (e) => {
        e.preventDefault();
        
        let ins = JSON.stringify({
            email_id: this.state.email_id,
            password: this.state.password
        });
        LoginCourse(ins).then((res) => {
            if (res.status === 1) {
               
                console.log(JSON.stringify(res.auth_data));

                localStorage.setItem('user_data', JSON.stringify(res.auth_data));
                localStorage.setItem('role', JSON.stringify(res.auth_data));
                localStorage.setItem('authentication', true);
                this.setState({logged:true, nouser:false});

                setTimeout(function () {
                    window.location.replace("/courses/dashboard");
                }, 1000);


                

            } else {
                this.setState({nouser:true});  
            }

        });
    };    

    componentDidMount() {

        let logged = localStorage.getItem("authentication");
        let auth_data = JSON.parse(localStorage.getItem("user_data"));
        console.log('auth_data.role', logged);
         
        if (logged === 'true' && auth_data !== 'null') {
          window.location.href = '/courses/dashboard';
        }         

    }     

    render() {

        return (
               <div class="container-fluid page-body-wrapper full-page-wrapper">
      <div class="content-wrapper d-flex align-items-center auth px-0">
        <div class="row w-100 mx-0">
          <div class="col-lg-4 mx-auto">
            <div class="auth-form-light text-left py-5 px-4 px-sm-5">
              <div class="brand-logo">
                <img src="../../images/bewiseLogo.png" alt="BeWise Logo" />
              </div>
              <h4>Hello! let's get started</h4>
              <h6 class="font-weight-light">Sign in to manage courses.</h6>
              <form class="pt-3" onSubmit={this.handleSubmitLogin} autoComplete='off' className="login-form" action="#">
                <div class="form-group">
                  <input type="email" name="email_id" class="form-control form-control-lg" id="email_id" placeholder="Email Id" onChange={this.handleChange} />
                </div>
                <div class="form-group">
                  <input type="password" name="password" class="form-control form-control-lg" id="password" placeholder="Password" onChange={this.handleChange} />
                </div>
                <div class="form-group">
                    <Recaptcha
                        sitekey={GOOGLE_CAPTCHA_SITE_KEY}
                        render="explicit"
                        onloadCallback={this.recaptchaLoaded}
                        verifyCallback={this.verifyCallback}
                    />
                </div>
                {!this.state.nouser && this.state.logged &&
                <div class="alert alert-success" role="alert">
                        Successful. You are logged in.
                </div>
                }
                {this.state.nouser && 
                <div class="alert alert-danger" role="alert">
                        User does not exist. Please Sign Up or Contact @BeWise
                </div>
                }
                <div class="mt-3">
                  <button type="submit" className="btn btn-block btn-primary btn-lg font-weight-medium auth-form-btn" >SIGN IN</button>
                </div>
                <div class="my-2 d-flex justify-content-between align-items-center">
                  <div class="form-check">
                     
                  </div>
                   
                </div>

              </form>
            </div>
          </div>
        </div>
      </div>
    </div>


        )
    }
}


export default CourseLogin;


// WEBPACK FOOTER //
// ./src/components/bewise/courselogin.jsx